import styled from 'styled-components';

export default styled.div`
  display: inline-block;
  opacity: ${({ isActive = true }) => (isActive ? 1.0 : 0.2)};
`;
